import React from 'react';
import styles from './index.module.sass';

const OnBoardingLayout = ({ children, className }) => {
  return <div className={`${styles.onboarding} ${className}`}>{children}</div>;
};

export default OnBoardingLayout;
